import { HubConnection } from "@microsoft/signalr/dist/esm/HubConnection";
import { HubConnectionBuilder } from "@microsoft/signalr/dist/esm/HubConnectionBuilder";
import { AttributesMixin, define, Model } from "@type-r/models";
import { getB2CToken, restfulIO } from "./endpoint";

export interface HubBuilder extends AttributesMixin<typeof HubBuilder> { }
@define
export class HubBuilder extends Model {
    static endpoint = restfulIO('');
    connection: HubConnection;
    estConnection: Promise<void>;

    establishConnection(hub: string) {
        const token = getB2CToken();
        const url = `${(this.getEndpoint() as any).getUrl(this)}/${hub}`;
        this.connection = new HubConnectionBuilder()
            .withUrl(url, { accessTokenFactory: () => token })
            // .withAutomaticReconnect()
            .build();

        this.estConnection = this.connection.start();
    }

    subscribe(methodName: string, callback: any) {
        this.estConnection.then(_ => {
            this.connection.on(methodName, response => {
                callback(response);
            });
        }).catch(error => console.log(error));
    }
} 
